/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { authClientsGetAudience } from "../funcs/authClientsGetAudience.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { AuthClientAudience } from "../models/components/authclientaudience.js";
import {
  GetAuthClientAudienceRequest,
  GetAuthClientAudienceSecurity,
} from "../models/operations/getauthclientaudience.js";
import { unwrapAsync } from "../types/fp.js";
export type AuthClientAudienceQueryData = AuthClientAudience;

export function prefetchAuthClientAudience(
  queryClient: QueryClient,
  client$: GramCore,
  request: GetAuthClientAudienceRequest,
  security?: GetAuthClientAudienceSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildAuthClientAudienceQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildAuthClientAudienceQuery(
  client$: GramCore,
  request: GetAuthClientAudienceRequest,
  security?: GetAuthClientAudienceSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<AuthClientAudienceQueryData>;
} {
  return {
    queryKey: queryKeyAuthClientAudience({
      id: request.id,
      gramSession: request.gramSession,
      gramKey: request.gramKey,
    }),
    queryFn: async function authClientAudienceQueryFn(
      ctx,
    ): Promise<AuthClientAudienceQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(authClientsGetAudience(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyAuthClientAudience(
  parameters: {
    id: string;
    gramSession?: string | undefined;
    gramKey?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "authClients", "getAudience", parameters];
}
